import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { ProfileResponseModel } from "../../models/user/profile-response.model";
import { UserRepository } from "../../repositories/user.repository";

export class SetProfilePhotoUseCase implements UseCase<File, ProfileResponseModel> {
    constructor(private userRepository: UserRepository) { }
    execute(
        params: File,
    ): Observable<ProfileResponseModel> {
        return this.userRepository.updateProfilePhoto(params);
    }
}
